import React from 'react'
import styled from 'styled-components'
import INFTProperty from './INFTProperty'

const NFTPropertyItem = styled.div`
  text-align: center;
  padding: 0.5rem;
  user-select: none;

  .wrapper {
    border: solid 1px ${({ theme }) => theme.yetiBlue};
    padding: 1rem;

    .type {
      font-size: 0.7rem;
      font-weight: 500;
      margin-bottom: 0.5rem;
      color: ${({ theme }) => theme.yetiBlue};
    }

    .name {
      font-size: 0.9rem;
      font-weight: bold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`

export default function NFTProperty({ name, type }: INFTProperty) {
  return (
    <NFTPropertyItem className="property-item">
      <div className="wrapper">
        <div className="type" title={type}>
          {type}
        </div>
        <div className="name" title={name}>
          {name}
        </div>
      </div>
    </NFTPropertyItem>
  )
}
